import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { RequestGenerationUpdateName } from '@shared/dto/generation/_requests/request_generation_update_name';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { FN_GENERATION__update_locally } from '../_methods/FN_GENERATION__update_locally';
import { STATE__generation } from '../STATE__generation';

export const remote_generation_update_name = createAsyncThunkSafe<void, RequestGenerationUpdateName>(
  ENUM__network_event_client_to_server.GENERATION_UPDATE_NAME,
  async (request: RequestGenerationUpdateName): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.GENERATION_UPDATE_NAME, request);
  },
);

export function init_remote_generation_update_name(builder: ActionReducerMapBuilder<STATE__generation>) {
  builder
    .addCase(remote_generation_update_name.pending, (state, action) => {
      let { name, generation_id } = action.meta.arg;

      let generation = state.generations_map.get_or_assert(generation_id, { context: 'generation' });

      generation = generation.clone({ name });

      FN_GENERATION__update_locally(state, generation);
    })
    .addCase(remote_generation_update_name.rejected, (state, action) => {})
    .addCase(remote_generation_update_name.fulfilled, (state, action: PayloadAction) => {});
}
